import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/home',
        component: Home,
        name: 'Home',
        redirect: '/welcome',
        children: [
            {
                path: '/welcome',
                name: 'Welcome',
                meta: { title: '欢迎页' },
                component: () => import('@/views/Welcome')
            }
        ]
    }
]

export const createNewRouter = () => createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

const router = createNewRouter()

// 重写 push/replace
const originalPush = router.push
const originalReplace = router.replace
router.push = async (to) => {
    try {
        return await originalPush(to)
    } catch (err) {
        return err
    }
}
router.replace = async (to) => {
    try {
        return await originalReplace(to)
    } catch (err) {
        return err
    }
}

export default router
export { createNewRouter as createRouter }
